import { isOneApp } from 'utils/device';

export enum PostMessageTypeEnum {
  PAYMENT_ARRANGEMENT_CREATED = 'PAYMENT_ARRANGEMENT_CREATED',
}

const postPaymentArrangementCreated = () => {
  if (isOneApp()) {
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: PostMessageTypeEnum.PAYMENT_ARRANGEMENT_CREATED,
      })
    );
  }
};

export const webviewMessage = {
  PostMessageTypeEnum,
  postPaymentArrangementCreated,
};
